// src/pages/Workflows/components/WorkflowCard.js

import React from 'react';

export default function WorkflowCard({ workflow, onEditar, onExecutar, onVerResultados, onEliminar, isAdmin }) {
  const dataFormatada = new Date(workflow.atualizado_em).toLocaleDateString('pt-PT', {
    day: '2-digit', month: '2-digit', year: 'numeric',
  });

  const nNos = workflow.n_nos ?? (workflow.definicao?.nodes?.length ?? 0);

  return (
    <div className="wf-card">
      <div className="wf-card-header">
        <div className="wf-card-title-row">
          <span className="wf-card-title">{workflow.nome}</span>
          <span className="wf-card-badge" title={workflow.visibilidade === 'shared' ? 'Partilhado' : 'Privado'}>
            {workflow.visibilidade === 'shared' ? '🔗' : '🔒'}
          </span>
        </div>
        {workflow.descricao && (
          <p className="wf-card-desc">{workflow.descricao}</p>
        )}
      </div>

      <div className="wf-card-meta">
        <span className="wf-card-nos">{nNos} nó{nNos !== 1 ? 's' : ''}</span>
        <span className="wf-card-date">{dataFormatada}</span>
      </div>

      <div className="wf-card-actions">
        {isAdmin && (
          <button className="wf-btn wf-btn-icon" title="Editar" onClick={() => onEditar(workflow.id)}>
            ✏️
          </button>
        )}
        <button className="wf-btn wf-btn-icon" title="Executar" onClick={() => onExecutar(workflow)}>
          ▶
        </button>
        <button className="wf-btn wf-btn-icon" title="Ver resultados" onClick={() => onVerResultados(workflow.id)}>
          📊
        </button>
        {isAdmin && (
          <button className="wf-btn wf-btn-icon wf-btn-danger" title="Eliminar" onClick={() => onEliminar(workflow)}>
            ✕
          </button>
        )}
      </div>
    </div>
  );
}
